import clsx from 'clsx'
import { motion } from 'motion/react'

const HINT_ARROW_SRC = '/images/tutorial/hintarrow.png'

type ControlHintArrowProps = {
    side: 'up' | 'left' | 'right' | 'down'
    className?: string
}

/** Arrow hint overlay (e.g. jump). */
export default function ControlHintArrow({
    side,
    className,
}: ControlHintArrowProps) {
    const isLeft = side === 'left'
    const isRight = side === 'right'
    const isUp = side === 'up'
    const isDown = side === 'down'

    return (
        <motion.img
            src={HINT_ARROW_SRC}
            alt=''
            aria-hidden
            draggable={false}
            animate={
                isUp
                    ? { y: [0, -20, 0] }
                    : isDown
                        ? { y: [0, 20, 0] }
                        : isLeft
                            ? { y: [0, -20, 0] }
                            : { y: [0, 20, 0] }
            }
            transition={{
                duration: 0.75,
                repeat: Infinity,
                ease: 'easeInOut',
            }}
            className={clsx(
                'z-20 absolute max-w-none object-contain pointer-events-none select-none',
                isLeft &&
                'rotate-270 left-1/4 bottom-1/5 -translate-x-1/2 -translate-y-1/2 scale-x-[-1] w-[min(36vw,140px)] stele:w-[520px]',
                isRight &&
                'rotate-90 right-1/4 bottom-1/5 translate-x-1/2 -translate-y-1/2 w-[min(36vw,140px)] stele:w-[520px]',
                isUp &&
                'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[min(36vw,140px)] stele:w-[520px]',
                isDown &&
                'left-1/2 bottom-10 -translate-x-1/2 -translate-y-1/2 w-[min(36vw,140px)] stele:w-[520px] rotate-180 stele:bottom-40',
                className,
            )}
        />
    )
}
